<template>
  <div id="carousel" class="carousel slide" data-bs-ride="carousel">
    <div class="biggStuff">
      <div class="carousel-indicators">
        <button
          type="button"
          data-bs-target="#carousel"
          data-bs-slide-to="0"
          class="active"
          aria-current="true"
          aria-label="Slide 1"
        ></button>
        <button
          type="button"
          data-bs-target="#carousel"
          data-bs-slide-to="1"
          aria-label="Slide 2"
        ></button>
        <button
          type="button"
          data-bs-target="#carousel"
          data-bs-slide-to="2"
          aria-label="Slide 3"
        ></button>
        <button
          type="button"
          data-bs-target="#carousel"
          data-bs-slide-to="3"
          aria-label="Slide 4"
        ></button>
      </div>
    </div>
    <div class="carousel-inner">
      <div class="carousel-item active" data-bs-interval="3000">
        <img :src="'../images/vehicles/Slide_1.JPG'" class="img img-fluid" />
      </div>
      <div class="carousel-item" data-bs-interval="3000">
        <img :src="'../images/vehicles/Slide_2.JPG'" class="img img-fluid" />
      </div>
      <div class="carousel-item" data-bs-interval="3000">
        <img :src="'../images/vehicles/Slide_3.JPG'" class="img img-fluid" />
      </div>
      <div class="carousel-item" data-bs-interval="3000">
        <img :src="'../images/vehicles/Slide_4.JPG'" class="img img-fluid" />
      </div>
    </div>
    <button
      class="carousel-control-prev"
      type="button"
      data-bs-target="#carousel"
      data-bs-slide="prev"
    >
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Previous</span>
    </button>
    <button
      class="carousel-control-next"
      type="button"
      data-bs-target="#carousel"
      data-bs-slide="next"
    >
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Next</span>
    </button>
  </div>
</template>
